import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { MessageService } from '../message.service';
import { BaseService } from '../base.service';
import { BehaviorSubject, Observable} from 'rxjs';
import { WorkflowItem } from 'src/app/models/workflow/workflow-item.model';
import { Workflow } from 'src/app/models/workflow/workflow.model';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService extends BaseService {

  private wsBase: string = "http://moj.semantika.si/api/";      

  // properties for observing when user adds new action to current workflow in workflow builder (editor)
  private addedAction = new BehaviorSubject<WorkflowItem>(new WorkflowItem("",0,"","","",null,0,"",""));
  currentAddedAction = this.addedAction.asObservable();

  // observer for workflowName
  private workflowName = new BehaviorSubject<string>("");
  currentWorkflowName = this.workflowName.asObservable();

  // workflow
  observableShareWorkflow: Observable<Workflow>; // store the shared observable
  observableResultWorkflow: Workflow; // store the result of the observable when complete

  workflowActions: WorkflowItem[] = [];
  private tempIdsList: any[] = [];

  constructor(http: HttpClient, messageService:MessageService) {
    super(http, messageService);
  }

  addActionToWorkflow(workflowAction: WorkflowItem) {    

    let workflowItem = Object.assign({}, workflowAction);

    if(typeof workflowItem.ClientId == "undefined" || workflowItem.ClientId == null){
        // generate random id
        let continueLoop = true;                
        let randomId = this.randomIntFromInterval(1, 100);
        
        while(continueLoop){ 
            // check if generated id exists in array
            let index = this.tempIdsList.findIndex(x => x == randomId);                    
            // if not found then generated id is good
            if(index < 0){
                this.tempIdsList.push(randomId);
                // client id consists of random number and action name                
                workflowItem.ClientId = workflowItem.ActionName + randomId.toString();
                continueLoop = false;
            }else{
                randomId = this.randomIntFromInterval(1,100);
            }
        }; 

    }

    this.addedAction.next(workflowItem);
  }

  changeWorkflowName(name: string){
    this.workflowName.next(name);
  }

  getAllActions() {
    
    if(this.workflowActions != null && this.workflowActions.length > 0){
      return this.workflowActions;
    } else {
      var url = this.wsBase + "actions/list";   
      this.dataGET<any[]>(url).subscribe( data => {
          
        data.forEach(item => {
          this.workflowActions.push(WorkflowItem.mapItem(item))
        });      
        }        
      );
    }      
  }

  saveWorkflow(workflowModel: Workflow) {
    var url = this.wsBase + "workflow/testsave";  
    
    if(workflowModel != null && typeof workflowModel != "undefined"){
      workflowModel.Title = this.workflowName.value;
    }

    this.dataPOST(url, workflowModel).subscribe(
      data => {
        alert("SAVED");
      })
  }

  getWorkflow(id: any) {
    var url = this.wsBase + "workflow/get/"+id;  
    
    this.observableShareWorkflow = this.dataPOST(url, {}).
      pipe(
        map((data: Workflow) => {
          this.observableResultWorkflow = data;
          return data;
        }));        

      return this.observableShareWorkflow;
  }

  private randomIntFromInterval(min,max) // min and max included
  {
    return Math.floor(Math.random()*(max-min+1)+min);
  }
}